/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContentManagementUpdateContentResponse } from './ContentManagementUpdateContentResponse';

export type ContentManagementUpdateContentResponseApiRespoonse = {
    data?: ContentManagementUpdateContentResponse;
    status?: ContentManagementUpdateContentResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ContentManagementUpdateContentResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

